import React from 'react';

export const IconCross = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4714 2.52876C13.7317 2.78911 13.7317 3.21122 13.4714 3.47157L8.94282 8.00012L13.4714 12.5288C13.7318 12.7891 13.7318 13.2112 13.4714 13.4716C13.2111 13.7319 12.789 13.7319 12.5286 13.4716L8.00002 8.94293L3.47145 13.4715C3.2111 13.7319 2.78899 13.7319 2.52864 13.4715C2.26829 13.2112 2.26829 12.7891 2.52864 12.5287L7.05721 8.00012L2.52872 3.47162C2.26837 3.21127 2.26837 2.78916 2.52872 2.52881C2.78907 2.26846 3.21118 2.26846 3.47153 2.52881L8.00002 7.05731L12.5286 2.52876C12.7889 2.26841 13.211 2.26841 13.4714 2.52876Z"
      fill="currentColor"
    />
  </svg>
);
